export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10321.78f7fd6d.jpg";